export interface ZxNavigationItem {
  icon: string;
  name: string;
  desc: string;
}

export interface ZxFunctionBranch {
  icon: string;
  title: string;
  points: string[];
}

export interface ZxModule {
  key: string;
  icon: string;
  name: string;
  alias: string;
  features: string[];
}

export interface ZxFlow {
  no: string;
  icon: string;
  name: string;
  steps: string[];
}

export interface ZxRole {
  icon: string;
  name: string;
  duty: string;
}

export const zxHero = {
  eyebrow: '客户案例 · 县域数智商贸',
  title: '中仙数智商贸',
  titleHighlight: '以数利民 · 以商带农 · 以虚促实',
  subtitle: '以「尤溪 ePin 云铺」为业务指挥中心，以「数字人民币智能合约」为结算底座。',
  desc: '构建覆盖农产品生产、品控溯源、市场经营、线上销售、仓储履约、消费激励和县域运营的数据化商贸平台，通过「千镇万铺智能体（云机甲）」连接政府、合作伙伴、返乡青年、商户和消费者。',
  imageUrl:
    'https://readdy.ai/api/search-image?query=Stylized%20county%20digital%20commerce%20platform%20scene%20combining%20a%20modern%20farmers%20market%20with%20digital%20storefront%20screens%2C%20fresh%20produce%20crates%20carrying%20QR%20traceability%20labels%2C%20subtle%20digital%20payment%20motifs%20and%20network%20lines%20connecting%20farm%20and%20city%2C%20deep%20graphite%20background%20with%20warm%20amber%20and%20muted%20green%20accents%2C%20clean%20minimal%20editorial%20illustration%2C%20no%20text%2C%20no%20people%2C%20high%20detail%2C%20harmonious%20composition&width=1600&height=900&seq=case-zhongxian-commerce-hero-01&orientation=landscape',
  imageAlt: '中仙数智商贸县域数字商贸平台客户案例',
};

export const zxStats = [
  { value: '7', unit: '大', label: '业务板块贯通产、销、链、金与治理' },
  { value: '6', unit: '大', label: '经营功能模块支撑市场与商户日常运营' },
  { value: '7', unit: '条', label: '核心业务流程覆盖入驻、溯源、交易与召回' },
  { value: '9', unit: '类', label: '系统角色协同县域数智商贸生态' },
];

export const zxPositioning = {
  paragraph:
    '中仙数智商贸以「尤溪 ePin 云铺」为业务指挥中心，以「数字人民币智能合约」为结算底座，构建覆盖农产品生产、品控溯源、市场经营、线上销售、仓储履约、消费激励和县域运营的数据化商贸平台。',
  bases: [
    {
      icon: 'ri-store-3-line',
      title: '尤溪 ePin 云铺',
      desc: '业务指挥中心',
    },
    {
      icon: 'ri-secure-payment-line',
      title: '数字人民币智能合约',
      desc: '结算底座',
    },
  ],
  claims: [
    {
      icon: 'ri-heart-3-line',
      title: '以数利民',
      desc: '以数字化手段服务城乡居民，让消费更实惠、更安心、更有获得感。',
    },
    {
      icon: 'ri-plant-line',
      title: '以商带农',
      desc: '以商贸流通带动农产品上行，让农户分享产业链的增值收益。',
    },
    {
      icon: 'ri-links-line',
      title: '以虚促实',
      desc: '以数字技术与平台能力反哺实体经营，促进实体经济提质增效。',
    },
  ],
  connective:
    '通过「千镇万铺智能体（云机甲）」连接政府、合作伙伴、返乡青年、商户和消费者，形成县域数智商贸的一张协同网络。',
};

export const zxNavigation: ZxNavigationItem[] = [
  {
    icon: 'ri-dashboard-3-line',
    name: '方案总览',
    desc: '展示平台定位、五层架构、云厨菜单、数商装备、角色体系、智能分账与县域价值留存。',
  },
  {
    icon: 'ri-qr-code-line',
    name: 'ePin 码',
    desc: '农产品一物一码、食安溯源、批次管理、检测、流转与召回。',
  },
  {
    icon: 'ri-red-packet-line',
    name: '数字红包',
    desc: '数字人民币消费激励、红包领取、核销、退款冲正与角色权限。',
  },
  {
    icon: 'ri-store-2-line',
    name: '逛农贸市场',
    desc: '中仙农贸市场数字化摊位、产地直供商品、食安码和消费服务。',
  },
  {
    icon: 'ri-shopping-bag-3-line',
    name: '逛京客隆',
    desc: '线上数字店铺、会员下单、到店提货、红包核销与产地商品销售。',
  },
  {
    icon: 'ri-computer-line',
    name: '体验管理后台',
    desc: '供应商/商户经营后台：商品、订单、会员、分账、食安、供应链。',
  },
  {
    icon: 'ri-add-circle-line',
    name: '我要开店／供应商入驻',
    desc: '供应商入驻、开通线下摊位与线上数字店铺、商品上架与渠道打通。',
  },
];

export const zxFunctionFramework: ZxFunctionBranch[] = [
  {
    icon: 'ri-building-4-line',
    title: '数智农贸市场经营',
    points: ['商户、摊位、合同与账单', '巡检、投诉、续约、退场', '市场经营报表与权限审计'],
  },
  {
    icon: 'ri-store-3-line',
    title: '商户与供应商经营',
    points: ['入驻、开店、商品、订单、会员', '采购、库存、供应链、分账台账', '线上数字店铺与渠道上架'],
  },
  {
    icon: 'ri-shield-check-line',
    title: 'ePin 食安溯源',
    points: ['种养档案、生产记录、批次', '检测、双层码、仓储流转', '消费者验真、售后与召回'],
  },
  {
    icon: 'ri-red-packet-line',
    title: '数字人民币与消费激励',
    points: ['钱包绑定、红包资格、红包发放', '线上抵扣、到店动态码核销', '退款撤销、冲正、智能分账'],
  },
  {
    icon: 'ri-truck-line',
    title: '全渠道交易与履约',
    points: ['中仙农贸市场消费', '京客隆线上店与到店提货', '采购、样品、入仓、结算'],
  },
  {
    icon: 'ri-government-line',
    title: '县域运营与生态协同',
    points: ['政府公共服务与数据看板', '合作伙伴共建与复制推广', '青年岗位、培训与成长体系', '云机甲角色与五级调度'],
  },
  {
    icon: 'ri-lock-2-line',
    title: '合规与安全',
    points: ['规则、合同、风险提示、授权说明', '隐私政策与用户协议', '权限、审计与操作留痕'],
  },
];

export const zxModules: ZxModule[] = [
  {
    key: 'market',
    icon: 'ri-building-4-line',
    name: '市场经营管理系统',
    alias: '对应网站「2980 市场经营管理系统」',
    features: [
      '商户全生命周期：入场申请、审核、签约、经营、续约、退场',
      '摊位管理：摊位建档、出租、分配、状态变更、空置管理',
      '合同与收费：租金、管理费、水电费账单自动生成、收款和核销',
      '市场巡检：巡检任务、问题登记、整改、验收和超时升级',
      '投诉工单：投诉受理、分派、处理、回访、自动升级',
      '风险提醒：合同到期、证照到期、逾期欠费、异常经营预警',
      '数据报表：出租率、收缴率、欠费、商户业态、巡检、投诉等经营报表',
      '权限与审计：按市场、岗位、角色配置数据权限，关键操作全程留痕',
    ],
  },
  {
    key: 'merchant',
    icon: 'ri-store-3-line',
    name: '商户/供应商经营后台',
    alias: '对应网站「体验管理后台」和「供应商 ePin 工作台」',
    features: [
      '商品管理：商品建档、规格、产地、库存、上架管理',
      '批次管理：生产批次建立、种养记录、初加工记录、批次状态',
      '订单管理：订单查看、接单、发货、配送、自提、签收和售后',
      '会员管理：会员信息、消费记录、消费激励、复购分析',
      '采购管理：采购需求、样品、采购单、入仓和结算',
      '分账台账：订单分账明细、结算批次、收益确认、差错处理',
      '食安资料：检测资料上传、检测结论、ePin 码申领与核验',
      '供应链管理：库存、仓储、流转、物流交接和异常处理',
    ],
  },
  {
    key: 'epin',
    icon: 'ri-shield-check-line',
    name: 'ePin 食安码与溯源平台',
    alias: '农产品一物一码 · 全链路食安溯源',
    features: [
      '农户工作台：播种/投苗建档、种养管理、农事留痕、采摘/出栏',
      '商品与批次：商品档案、生产批次、初加工、包装和赋码',
      '检测管理：检测资料提交、检测结果录入、报告关联、复检管理',
      'ePin 双层码：主码与子批次码、签发、状态管理、失效与作废',
      '仓储门店扫码：入库、出库、运输交接、签收、上架、下架、报损、盘点',
      '消费者验真：扫码、上传二维码或手动输入溯源码，查看产地、检测和流转',
      '风险处置：停售、冻结、召回、反查受影响订单、消费者通知和售后',
      '溯源数字护照：展示商品信息、生产主体、检测结论、流转轨迹和售后入口',
    ],
  },
  {
    key: 'digital-yuan',
    icon: 'ri-red-packet-line',
    name: '数字人民币红包与智能分账',
    alias: '消费激励 · 智能合约结算',
    features: [
      '云市民注册与钱包绑定',
      '活动规则管理：适用商品、适用门店、最低消费、有效期、预算、限领规则',
      '消费累计与资格计算',
      '红包发放：发放资格、数字人民币交易流水、待领取/可使用/已使用/已失效状态',
      '核销方式：线上订单直接抵扣；线下门店 60 秒动态码核销',
      '白名单商户管理：限定可核销门店和适用场景',
      '退款与冲正：退款、拒收、批次召回后撤销未使用红包；已使用红包生成冲正任务',
      '智能分账：依据合同、订单与规则自动拆分参与方收益，形成可查询、可结算的分账台账',
      '对账风控：平台流水、支付机构流水、差异任务、人工审核和审计留痕',
    ],
  },
  {
    key: 'fulfillment',
    icon: 'ri-truck-line',
    name: '全渠道销售与履约',
    alias: '线下摊位 · 线上店铺 · 仓储履约',
    features: [
      '中仙农贸市场：线下摊位选购、产地直供、扫码溯源、消费激励',
      '京客隆线上店：商品一键上架、会员下单、线上支付、到店提货',
      '云厨菜单/数字货架：聚合商品展示、组合销售、活动商品和线上下单',
      '供应商采购协同：采购需求、样品寄送、验货、入仓和结算',
      '仓储履约：扫码入出库、运输交接、门店签收、上架、库存盘点',
      '消费者服务：订单查询、配送/自提、退款、投诉、质量反馈、召回通知',
    ],
  },
  {
    key: 'county',
    icon: 'ri-government-line',
    name: '县域运营与生态协同',
    alias: '政府 · 合作 · 青年 · 云机甲',
    features: [
      '政府端：县域交易、就业、农户增收、集体经济、税收、品牌、复制进度看板',
      '合作端：银行、商超、供应链、渠道、技术合作申请和项目协同',
      '青年端：云农人、云掌柜、云店长、云创客、云调度等岗位成长路径',
      '五级调度：从基层执行到县域统筹的组织协同和任务调度',
      '云机甲：按身份生成数字角色，为不同角色匹配任务、权益和服务能力',
      '合作招募：合作方加盟、青年岗位申请、城市云店长招募、政府机构对接',
    ],
  },
];

export const zxFlows: ZxFlow[] = [
  {
    no: '01',
    icon: 'ri-user-add-line',
    name: '供应商入驻与渠道打通流程',
    steps: [
      '提交入驻申请',
      '资格与资料审核',
      '开通市场摊位及线上数字店铺',
      '商品建档与商品上架',
      '生产批次建立、检测资料提交',
      'ePin 食安码签发/上链',
      '对接京客隆及线上渠道',
      '会员下单与订单履约',
      '智能分账与经营数据回流',
    ],
  },
  {
    no: '02',
    icon: 'ri-qr-code-line',
    name: '农产品 ePin 溯源流程',
    steps: [
      '种养/初加工建档',
      '农事留痕',
      '采摘或出栏登记',
      '生产批次建立',
      '检测与审核',
      'ePin 双层码签发',
      '仓储、运输、门店流转扫码',
      '消费者扫码验真、购买与售后',
    ],
  },
  {
    no: '03',
    icon: 'ri-shopping-cart-2-line',
    name: '京客隆采购流程',
    steps: [
      '供应商入驻',
      '发布商品',
      '采购方发布采购需求',
      '样品寄送与验货',
      '商品/批次上链',
      '入仓',
      '订单交付',
      '结算与分账',
    ],
  },
  {
    no: '04',
    icon: 'ri-store-2-line',
    name: '京客隆卖货与消费者履约流程',
    steps: [
      '活动券/消费权益核发',
      '消费者线上下单',
      '线上支付或数字红包抵扣',
      '门店提货/配送签收',
      '红包资格生成与领取',
      '智能合约分账',
      '消费者复购',
      '订单、消费和经营数据回流',
    ],
  },
  {
    no: '05',
    icon: 'ri-red-packet-line',
    name: '数字人民币红包流程',
    steps: [
      '云市民注册',
      '绑定数字人民币钱包',
      '在活动商品/门店消费',
      '系统累计消费并校验资格',
      '发放红包',
      '线上抵扣或到店动态码核销',
      '订单完成与智能分账',
      '退款、拒收或召回时撤销/冲正',
    ],
  },
  {
    no: '06',
    icon: 'ri-building-4-line',
    name: '市场经营管理流程',
    steps: [
      '商户申请入场',
      '资质审核',
      '摊位分配',
      '合同签约',
      '租金/管理费/水电费账单生成',
      '收款与核销',
      '日常巡检与投诉处理',
      '续约或退场',
    ],
  },
  {
    no: '07',
    icon: 'ri-alert-line',
    name: '食安异常与召回流程',
    steps: [
      '检测异常/投诉/风险发现',
      '冻结或停售相关批次',
      '反查仓储、门店与销售订单',
      '下架、阻断购买与核销',
      '通知商户及消费者',
      '退款、召回与红包冲正',
      '整改复检',
      '恢复销售或归档关闭',
    ],
  },
];

export const zxRoles: ZxRole[] = [
  { icon: 'ri-government-line', name: '政府及集体经济组织', duty: '监管、公共服务、县域经营与产业数据决策' },
  { icon: 'ri-building-4-line', name: '市场运营方', duty: '商户、摊位、合同、收费、巡检、投诉和经营管理' },
  { icon: 'ri-plant-line', name: '农户/生产主体', duty: '种养建档、农事记录、采收出栏和批次申报' },
  { icon: 'ri-store-3-line', name: '供应商/商户', duty: '商品、订单、库存、采购、履约、经营与分账' },
  { icon: 'ri-archive-2-line', name: '仓储/门店', duty: '商品交接、扫码入出库、上架、盘点和核销' },
  { icon: 'ri-bank-line', name: '银行/支付机构', duty: '数字人民币钱包、红包发放、资金清分和对账' },
  { icon: 'ri-team-line', name: '合作伙伴', duty: '渠道、商超、供应链、技术与运营共建' },
  { icon: 'ri-robot-2-line', name: '返乡青年/云机甲', duty: '岗位推广、运营、服务、门店拓展、区域调度' },
  { icon: 'ri-user-heart-line', name: '云社员/消费者', duty: '注册、消费、溯源、领取红包、核销、评价和售后' },
];

export const zxRelated = {
  solutions: [
    { label: '智慧农场解决方案', href: '/solutions/smart-farm' },
    { label: 'ePin 食安码', href: '/cases/epin-food-safety' },
    { label: '数字红包解决方案', href: '/solutions/red-packet' },
    { label: '智慧农业解决方案', href: '/solutions/smart-agriculture' },
  ],
};